// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"32231ece","239":"54b50c9c","455":"e3f5fa69"}[chunkId] + ".chunk.js";
};